import { VariantProps, tv } from '../cn';

export const inputVariants = tv({
  base: 'rounded border border-transparent bg-transparent p-2 outline-none focus:border-border-accent-quaternary',
  variants: {
    color: {
      default: 'text-text-secondary',
      error:
        'border-text-negative hover:border-text-negative/40 focus:border-text-negative/80',
    },
    size: {
      xs: 'text-xs',
      sm: 'p-1 text-sm',
      md: '',
      lg: 'text-lg',
    },
    variant: {
      default:
        'border-bg-quaternary hover:border-border-secondary focus:border-border-accent-quaternary',
      subtle:
        'border-transparent hover:bg-bg-quaternary focus:border-bg-secondary',
    },
    disabled: {
      true: 'pointer-events-none',
    },
  },
  defaultVariants: {
    color: 'default',
    size: 'md',
    variant: 'default',
    disabled: false,
  },
});

export type InputVariants = VariantProps<typeof inputVariants>;
